import { render, staticRenderFns } from "./TicketsMonthSummary.vue?vue&type=template&id=34cb6ed8&scoped=true&"
import script from "./TicketsMonthSummary.vue?vue&type=script&lang=ts&"
export * from "./TicketsMonthSummary.vue?vue&type=script&lang=ts&"
import style0 from "./TicketsMonthSummary.vue?vue&type=style&index=0&id=34cb6ed8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34cb6ed8",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VCardText,VCardTitle,VSkeletonLoader})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34cb6ed8')) {
      api.createRecord('34cb6ed8', component.options)
    } else {
      api.reload('34cb6ed8', component.options)
    }
    module.hot.accept("./TicketsMonthSummary.vue?vue&type=template&id=34cb6ed8&scoped=true&", function () {
      api.rerender('34cb6ed8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tickets/dashboard/components/TicketsMonthSummary.vue"
export default component.exports